<template>
  <div class="failure-statistics">
    <div class="failure-statistics-title">
      <h2>{{ $t('home_fault_ranking') }}</h2>
      <div class="failure-statistics-title-right">
        <!-- 选故障类型 -->
        <a-select @change="handleFailureTypeChange" class="mr12" v-model="failureTypeValue">
          <a-select-option :value="item.value" v-for="item in failureTypeList" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>

        <!-- 选日期时间 -->
        <a-range-picker
          format="YYYY/MM/DD"
          @change="handleFailureDate"
          class="mr12 date-picker"
          v-model="failureDate"
          :disabled-date="disabledDate"
          :allowClear="false"
        />
        <a-button type="primary" @click="handleFailure" class="mr12">
          {{ $t('com_btn_lookfor') }}
        </a-button>
        <a-button type="default" @click="handleFailureReset">
          {{ $t('com_btn_reset') }}
        </a-button>
      </div>
    </div>
    <div class="failure-statistics-content g-table-small">
      <a-table
        :columns="columns"
        :data-source="dataList"
        bordered
        rowKey="devId"
        :loading="loading"
        :pagination="false"
        size="small"
      >
        <!-- 时间 -->
        <template slot="totalDurationTime" slot-scope="text">
          {{ text | formatSeconds }}
        </template>
      </a-table>
      <div class="pagination">
        <Pagination
          :current.sync="pagination.current"
          :total="pagination.total"
          :pageSize.sync="pagination.pageSize"
          :callback="pageChange"
          @change="pageChange"
          :showSizeChanger="false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { DeviceFaultRank } from '@/api/home';
import moment from 'moment';

export default {
  data() {
    return {
      // 故障类型，默认为故障(Unavailable)；1-离线(offline)，2-告警(Alarm)，3-故障(Unavailable)。不填时则默认值为3
      failureTypeValue: 3,
      failureTypeList: [
        {
          value: 1,
          label: this.$t('com_fault_type_offline'),
        },
        {
          value: 2,
          label: this.$t('com_fault_type_alarm'),
        },
        {
          value: 3,
          label: this.$t('com_fault_type_unavailable'),
        },
      ],
      failureDateDefault: [
        // 默认查询当前到一个月前的数据
        moment().subtract(1, 'months'),
        moment().endOf('day'),
      ],
      failureDate: null,
      failureStartTime: null,
      failureEndTime: new Date().getTime(),
      dataList: [],

      loading: false,
      columns: [
        {
          title: this.$t('com_table_index'),
          align: 'center',
          width: 50,
          customRender: (text, record, index) => {
            return (this.pagination.current - 1) * this.pagination.pageSize + (index + 1);
          },
        },
        // 名称
        {
          title: this.$t('com_table_device_name'),
          align: 'center',
          dataIndex: 'name',
          width: 130,
        },

        // 故障时间
        {
          title: this.$t('com_table_falut_time'),
          align: 'center',
          dataIndex: 'totalDurationTime',
          width: 130,
          scopedSlots: { customRender: 'totalDurationTime' },
        },

        // 故障次数
        {
          title: this.$t('com_table_fault_count'),
          align: 'center',
          dataIndex: 'totalDurationFrequency',
          width: 130,
        },
      ],

      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 5,
        // 记录总条数
        total: 0,
      },
    };
  },
  created() {
    // 默认查询当前到一年前的数据
    this.handleFailureReset();

    this.getFailureRank();
  },
  methods: {
    // 分页
    pageChange(value) {
      this.pagination.current = value;
      this.getFailureRank();
    },

    // 获取故障排行
    async getFailureRank() {
      const params = {
        type: this.failureTypeValue,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };
      if (this.failureStartTime) {
        params.startTime = new Date(this.failureStartTime.format('YYYY/MM/DD 00:00:00')).getTime();
      }

      if (this.failureEndTime) {
        params.endTime = new Date(this.failureEndTime.format('YYYY/MM/DD 23:59:59')).getTime();
      }

      this.loading = true;
      const res = await DeviceFaultRank(params);
      this.loading = false;
      if (res.code === 0) {
        this.dataList = res.data;

        // 总数
        this.pagination.total = res.totalCount;
      }
    },

    // 切换故障统计类型
    handleFailureTypeChange(value) {
      this.failureTypeValue = value;
      this.getFailureRank();
    },

    // 切换故障统计日期
    handleFailureDate(value) {
      console.log(value);
      if (value) {
        this.failureDate = value;
        this.failureStartTime = value[0];
        this.failureEndTime = value[1];

        this.getFailureRank();
      }
    },

    // 查询
    handleFailure() {
      this.getFailureRank();
    },

    // 重置
    handleFailureReset() {
      //
      this.failureTypeValue = 3;
      this.failureDate = this.failureDateDefault;
      this.failureStartTime = this.failureDate[0];
      this.failureEndTime = this.failureDate[1];

      this.getFailureRank();
    },

    // disabledDate
    disabledDate(current) {
      // 禁用未来时间
      const disabledFuture = current && current > moment().endOf('day');
      // const disabledOneYearAgo =
      //   current && current < moment().subtract(1, 'years');

      // 禁用未来时间和一年前的时间
      return disabledFuture;
    },
  },
};
</script>
<style lang="less" scoped>
.failure-statistics {
  // title
  .failure-statistics-title {
    color: #18181a;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      margin: 0;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
    }
    .failure-statistics-title-right {
      display: flex;
      align-items: center;
    }

    .mr12 {
      margin-right: 12px;
    }

    .date-picker {
      width: 210px;
    }
  }

  // content
  .failure-statistics-content {
    margin-top: 16px;
  }
}
</style>
